import React from 'react';

export const InvestInGrowth = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.9572 47.0536C59.9491 52.245 56.2006 56.5787 51.0943 58.3541C47.751 59.5161 44.0117 59.5246 40.554 58.2011C39.9671 57.9788 40.0003 56.4473 40.0003 55.8947C40.001 51.3158 44.8143 47.4709 49.9082 45.6998C53.2503 44.5367 56.9908 44.527 60.4492 45.8517C61.0318 46.0728 61.0526 46.5635 60.9572 47.0536Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.6592 15.3646C45.142 18.8384 47.3671 24.3313 46.4152 29.7664C45.7914 33.3248 43.8481 36.6643 40.7666 39.0921C40.2458 39.5053 39.7635 39.2795 39.3389 38.9498C34.8421 35.4581 32.6369 29.9704 33.5866 24.5484C34.2085 20.9906 36.1513 17.6493 39.2343 15.2216C39.7517 14.8116 40.2361 15.0363 40.6592 15.3646Z"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8225 41.2364C24.9288 39.5223 30.6575 40.5451 34.8052 43.9779C37.5204 46.2257 39.4138 49.3777 39.9855 52.9502C40.0846 53.5554 39.6606 53.8134 39.1764 53.9753C34.0483 55.6912 28.3335 54.6558 24.1959 51.2313C21.4802 48.9851 19.5851 45.8326 19.0142 42.259C18.9162 41.6581 19.3403 41.398 19.8225 41.2364Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M40 64.7367V30.4736"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
